import * as React from 'react'
import type { SVGProps } from 'react'
function SvgWohnraumWohnflache2219826271105(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 242.6 200.9"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M242.5,185.5L220.2,11.9C219.3,5.1,213.5,0,206.6,0H37.7c-6.8,0-12.6,5.1-13.6,11.8l-24,173.6c-0.5,3.9,0.6,7.9,3.2,10.9 c2.6,3,6.4,4.7,10.3,4.7H229c3.9,0,7.7-1.7,10.3-4.6C241.8,193.4,243,189.4,242.5,185.5z M37.7,6.1h168.9c3.8,0,7,2.8,7.5,6.6 l22.3,173.6c0.3,2.2-0.4,4.3-1.8,6c-1.4,1.6-3.5,2.6-5.7,2.6H13.7c-2.2,0-4.3-0.9-5.7-2.6c-1.4-1.7-2.1-3.9-1.8-6l24-173.6 C30.7,8.9,34,6.1,37.7,6.1z" />
        <path d="M38.7,159.3h11.8l-0.9,11.6c-0.1,0.8,0.2,1.6,0.7,2.2c0.3,0.4,0.8,0.7,1.3,0.9l-0.2,0.2h1.2c1.6,0,2.9-1.2,3-2.8l1-12.1 h129.6l0.9,12c0.1,1.6,1.5,2.8,3,2.8l0.5,0v0c1.5-0.3,2.7-1.7,2.5-3.2l-0.9-11.6H204c1.7,0,3-1.4,3-3c0-1.7-1.4-3.1-3-3.1h-12.2 l-4.1-54.4h10.7c1.7,0,3-1.4,3-3c0-1.7-1.4-3.1-3-3.1h-11.2l-0.9-12c-0.1-1.7-1.6-2.9-3.3-2.8c-0.8,0.1-1.5,0.4-2.1,1.1 c-0.5,0.6-0.8,1.4-0.7,2.2l0.9,11.5h-56.7v-49h9.1c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3-3.1-3h-9.1v-8.9c0-1.7-1.4-3.1-3.1-3.1 c-1.7,0-3,1.4-3,3.1v8.9H66.5l0.9-10.9c0.1-0.8-0.2-1.6-0.7-2.2c-0.5-0.6-1.3-1-2.1-1.1c-1.7-0.1-3.1,1.1-3.3,2.8l-0.9,11.4H49.6 c-1.7,0-3,1.4-3,3c0,1.7,1.4,3.1,3,3.1h10.3L51,153.2H38.7c-1.7,0-3.1,1.4-3.1,3.1C35.6,157.9,37,159.3,38.7,159.3z M121.3,98.7 h60.3l4.1,54.4H57.1L66,43.6h52.3v52.1C118.3,97.4,119.6,98.7,121.3,98.7z" />
        <path d="M97.5,124.6H80.9c-1.7,0-3.1,1.4-3.1,3s1.4,3,3.1,3h16.7c1.7,0,3-1.4,3-3S99.2,124.6,97.5,124.6z" />
        <path d="M121.3,130.7H138c1.7,0,3-1.4,3-3s-1.4-3-3-3h-16.7c-1.7,0-3,1.4-3,3S119.6,130.7,121.3,130.7z" />
      </g>
    </svg>
  )
}
export default SvgWohnraumWohnflache2219826271105
